import React, { useState } from 'react'
import { Accordion } from 'react-bootstrap'
import { RiMoneyRupeeCircleFill } from "react-icons/ri"
import './MobileNavbarAdminCSS.css'
import { useNavigate, useLocation } from 'react-router-dom'

const MobileNavbarAdmin = () => {
  const [activeKey, setActiveKey] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
    const location = useLocation()
  const flag = Number(sessionStorage.getItem('flag'))

  const toggleMenu = () => setIsOpen(!isOpen)

  const handleNavigate = (url) => {
    navigate(url)
    setIsOpen(false)
  }

  const handleBack = () => {
  if (document.referrer) {
    navigate(-1)
  } else {
    navigate('/HomeAdmin')
  }
}

  return (
    <div className="mobile-navbar-admin">
      <div className="navbar-header d-flex justify-content-between p-2">
      <i className="fa fa-arrow-left back-icon" style={{color:"#fff",cursor:"pointer",fontSize:"18px"}} onClick={handleBack}></i>
        {/* <span style={{ fontWeight: 'bold' }}>Admin Panel</span> */}
        <i className="fa fa-bars" onClick={toggleMenu} style={{ cursor: 'pointer' }} />
      </div>

      {isOpen && (
        <div className="navbar-dropdown p-2" style={{backgroundColor:"#a2d6f8"}}>
          {(flag === 1 || flag === 2 || flag === 3 || flag === 4) && (
            <div className="mb-2" onClick={() => handleNavigate('/HomeAdmin')}>
              <i className="fa fa-line-chart me-2" />
              Dashboard
            </div>
          )}

         {/* === Approvals Dropdown === */}
          {(flag === 1 || flag === 2 || flag === 3) && (
            <>
              <div
                onClick={() => setActiveKey(activeKey === '1' ? null : '1')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px 15px',
                  cursor: 'pointer',
                  // borderBottom: '1px solid #ddd',
                  background: '#a2d6f8',
                }}
              >
                <span>
                  <i className="fa-solid fa-person-circle-check me-2" />
                  Approvals
                </span>
                <span>{activeKey === '1' ? '▲' : '▼'}</span>
              </div>

              {activeKey === '1' && (
                <div style={{ paddingLeft: '30px', background: '#a2d6f8' }}>
                  {(flag === 1 || flag === 3) && (
                    <div onClick={() => handleNavigate('/Reg50Approval')} style={{ padding: '8px 0', cursor: 'pointer' }}>
                      <i className="fa-solid fa-file me-2"></i> Application Approval
                    </div>
                  )}
                  {(flag === 1 || flag === 2) && (
                    <div onClick={() => handleNavigate('/StudentView')} style={{ padding: '8px 0', cursor: 'pointer' }}>
                      <i className="fa-solid fa-user me-2"></i> Member Approval
                    </div>
                  )}
                  {(flag === 1 || flag === 3) && (
                    <div onClick={() => handleNavigate('/payment')} style={{ padding: '8px 0', cursor: 'pointer' }}>
                      <RiMoneyRupeeCircleFill className="me-2" /> Payment Approval
                    </div>
                  )}
                  {(flag === 1 || flag === 3) && (
                    <div onClick={() => handleNavigate('/JobApproval')} style={{ padding: '8px 0', cursor: 'pointer' }}>
                      <i className="fa-solid fa-bag-shopping me-2"></i> Job Approval
                    </div>
                  )}
                  {(flag === 1 || flag === 2) && (
                    <div onClick={() => handleNavigate('/RegularAndEventLeaveApprove')} style={{ padding: '8px 0', cursor: 'pointer' }}>
                      <i className="fa-solid fa-newspaper me-2"></i> Regular Leave Approval
                    </div>
                  )}
                  {(flag === 1 || flag === 2) && (
                    <div onClick={() => handleNavigate('/EventLeaveApprove')} style={{ padding: '8px 0', cursor: 'pointer' }}>
                      <i className="fa-solid fa-pager me-2"></i> Event Leave Approval
                    </div>
                  )}
                  {flag === 1 && (
                    <div onClick={() => handleNavigate('/MessLeaveApprove')} style={{ padding: '8px 0', cursor: 'pointer' }}>
                      <i className="fa-solid fa-bowl-food me-2"></i> Mess Leave Approval
                    </div>
                  )}
                </div>
              )}
            </>
          )}


          {/* Menu List (flag == 2) */}
          {flag === 2 && (
            <div className="mt-2" onClick={() => handleNavigate('/MessMenuMaster')}>
              <i className="fa-solid fa-plate-wheat me-2" />
              Menu List
            </div>
          )}

          
          {/* Main Admin Mess (flag == 1) */}
          {flag === 1 && (
            <>
            <div
              onClick={() => setActiveKey(activeKey === '6' ? null : '6')}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 15px',
                cursor: 'pointer',
                // borderBottom: '1px solid #ddd',
                background: '#a2d6f8',
              }}
            >
              <span>
                <i className="fa-solid fa-bowl-rice me-2" />
                Mess
              </span>
              <span>{activeKey === '6' ? '▲' : '▼'}</span>
            </div>

            {activeKey === '6' && (
              <div style={{ paddingLeft: '30px', background: '#fff' }}>
                <div
                  onClick={() => handleNavigate('/MessMenuMaster')}
                  style={{ padding: '8px 0', cursor: 'pointer' }}
                >
                  <i className="fa-solid fa-plate-wheat me-2" /> Menu Master
                </div>
                <div
                  onClick={() => handleNavigate('/BreakfastmenuMaster')}
                  style={{ padding: '8px 0', cursor: 'pointer' }}
                >
                  <i className="fa-solid fa-hot-tub-person me-2" /> Breakfast Master
                </div>
                <div
                  onClick={() => handleNavigate('/MessAttendanceAdmin')}
                  style={{ padding: '8px 0', cursor: 'pointer' }}
                >
                  <i className="fa-solid fa-clipboard-user me-2" /> Mess Attendance
                </div>
                <div
                  onClick={() => handleNavigate('/RequestRec')}
                  style={{ padding: '8px 0', cursor: 'pointer' }}
                >
                  <i className="fa-solid fa-bell-concierge me-2" /> Breakfast Request
                </div>
                <div
                  onClick={() => handleNavigate('/FeedBack')}
                  style={{ padding: '8px 0', cursor: 'pointer' }}
                >
                  <i className="fa-solid fa-pager me-2" /> Mess Feedback
                </div>
              </div>
            )}
            </>
          )}

          {/* Mess Admin (flag == 4) */}
          {flag === 4 && (
            <>
              <div onClick={() => handleNavigate('/MessAttendanceAdmin')}>
                <i className="fa-solid fa-clipboard-user me-2" /> Attendance
              </div>
              <div onClick={() => handleNavigate('/MessLeaveApproval')}>
                <i className="fa-solid fa-bowl-food me-2" /> Mess Leave Approval
              </div>
              <div onClick={() => handleNavigate('/RequestRec')}>
                <i className="fa-solid fa-bell-concierge me-2" /> Breakfast Request
              </div>
              <div onClick={() => handleNavigate('/event')}>
                <i className="fa-solid fa-calendar-days me-2" /> Event List
              </div>
              <div onClick={() => handleNavigate('/MessMenuMaster')}>
                <i className="fa-solid fa-plate-wheat me-2" /> Menu Master
              </div>
              <div onClick={() => handleNavigate('/BreakfastmenuMaster')}>
                <i className="fa-solid fa-hot-tub-person me-2" /> Breakfast Master
              </div>
              <div onClick={() => handleNavigate('/FeedBack')}>
                <i className="fa-solid fa-pager me-2" /> Feedback
              </div>
            </>
          )}

          {/* Room Change */}
          {(flag === 1 || flag === 2) && (
            <div onClick={() => handleNavigate('/RoomChange')}>
              <i className="fa-solid fa-house-user me-2" /> Room Change
            </div>
          )}

          {/* Complaints */}
          {(flag === 1 || flag === 2 || flag === 3 || flag === 4) && (
            <div onClick={() => handleNavigate('/complaint')}>
              <i className="fa-solid fa-file-lines me-2" /> Complaints
            </div>
          )}

          {/* ======== Event ========= */}
          {(flag === 1 || flag === 2 || flag === 3) && (
            <>
            <div
              onClick={() => setActiveKey(activeKey === '5' ? null : '5')}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 15px',
                cursor: 'pointer',
                // borderBottom: '1px solid #ddd',
                background: '#a2d6f8',
              }}
            >
              <span>
                <i className="fa-solid fa-calendar-days me-2" />
                Event
              </span>
              <span>{activeKey === '5' ? '▲' : '▼'}</span>
            </div>

            {activeKey === '5' && (
              <div style={{ paddingLeft: '30px', background: '#fff' }}>
                <div
                  onClick={() => handleNavigate('/event')}
                  style={{ padding: '8px 0', cursor: 'pointer' }}
                >
                  <i className="fa-solid fa-calendar-days me-2" />
                  {flag === 1 ? 'Add Events' : 'Event List'}
                </div>

                {(flag === 1 || flag === 2) && (
                  <div
                    onClick={() => handleNavigate('/EventAttendance')}
                    style={{ padding: '8px 0', cursor: 'pointer' }}
                  >
                    <i className="fa-solid fa-clipboard-user me-2" />
                    Event Attendance
                  </div>
                )}
              </div>
            )}
            </>
          )}

          {/* ======== Jobs ========= */}
          {(flag === 1 || flag === 2 || flag === 3) && (
           <>
              <div
                onClick={() => setActiveKey(activeKey === '3' ? null : '3')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px 15px',
                  cursor: 'pointer',
                  // borderBottom: '1px solid #ddd',
                  background: '#a2d6f8',
                }}
              >
                <span>
                  <i className="fa-solid fa-bag-shopping me-2" />
                  Jobs
                </span>
                <span>{activeKey === '3' ? '▲' : '▼'}</span>
              </div>

              {activeKey === '3' && (
                <div style={{ paddingLeft: '30px', background: '#fff' }}>
                  {(flag === 1 || flag === 3) && (
                    <div
                      onClick={() => handleNavigate('/JobCategoryMaster')}
                      style={{ padding: '8px 0', cursor: 'pointer' }}
                    >
                      <i className="fa-solid fa-layer-group me-2" />
                      Job Category Master
                    </div>
                  )}
                  <div
                    onClick={() => handleNavigate('/JobpostAdmin')}
                    style={{ padding: '8px 0', cursor: 'pointer' }}
                  >
                    <i className="fa-solid fa-folder-plus me-2" />
                    Job Post
                  </div>
                  <div
                    onClick={() => handleNavigate('/Alljob')}
                    style={{ padding: '8px 0', cursor: 'pointer' }}
                  >
                    <i className="fa-solid fa-list me-2" />
                    All Job Data
                  </div>
                </div>
              )}
           </>
          )}

          {/* ======== To Do (Main Admin) ========= */}
          {flag === 1 && (
            <div onClick={() => handleNavigate('/ToDoMainAdmin')}>
              <i className="fa-solid fa-clipboard-list me-2" /> To Do
            </div>
          )}

          {/* ======== Task To Do (Other Admins) ========= */}
          {(flag === 2 || flag === 3 || flag === 4) && (
            <div onClick={() => handleNavigate('/ToDoAllAdmin')}>
              <i className="fa-solid fa-clipboard-list me-2" /> Task To Do
            </div>
          )}

          {/* ======== Donation List ========= */}
          {(flag === 1 || flag === 3) && (
            <div onClick={() => handleNavigate('/DonationList')}>
              <i className="fa-solid fa-hand-holding-dollar me-2" /> Donation List
            </div>
          )}

          {/* ======== Alumini List ========= */}
          {(flag === 1 || flag === 2 || flag === 3) && (
            <div onClick={() => handleNavigate('/AluminiList')}>
              <i className="fa-solid fa-users me-2" /> Alumni List
            </div>
          )}

          {/* ======== Suggestions ========= */}
          {(flag === 1 || flag === 2 || flag === 3) && (
            <div onClick={() => handleNavigate('/SuggestionAll')}>
              <i className="fa-regular fa-file me-2" /> Suggestions
            </div>
          )}

          {/* ======== Reports ========= */}
          {(flag === 1 || flag === 2 || flag === 3) && (
            <div onClick={() => handleNavigate('/AdminDashboardReport')}>
              <i className="fa-solid fa-border-all me-2" /> Reports
            </div>
          )}
          {flag === 4 && (
            <div onClick={() => handleNavigate('/MessWiseAttendance')}>
              <i className="fa-solid fa-border-all me-2" /> Reports
            </div>
          )}

          {/* ======== Discharge ========= */}
          {(flag === 1 || flag === 2 || flag === 3) && (
           <>
              <div
                onClick={() => setActiveKey(activeKey === '7' ? null : '7')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px 15px',
                  cursor: 'pointer',
                  // borderBottom: '1px solid #ddd',
                  background: '#a2d6f8',
                }}
              >
                <span>
                  <i className="fa-solid fa-eject me-2" />
                  Discharge
                </span>
                <span>{activeKey === '7' ? '▲' : '▼'}</span>
              </div>

              {activeKey === '7' && (
                <div style={{ paddingLeft: '30px', background: '#fff' }}>
                  {(flag === 1 || flag === 2) && (
                    <div
                      onClick={() => handleNavigate('/Discharge')}
                      style={{ padding: '8px 0', cursor: 'pointer' }}
                    >
                      <i className="fa-solid fa-user me-2" />
                      Discharge (Superi.)
                    </div>
                  )}
                  {(flag === 1 || flag === 3) && (
                    <div
                      onClick={() => handleNavigate('/Admin2Discharge')}
                      style={{ padding: '8px 0', cursor: 'pointer' }}
                    >
                      <i className="fa-solid fa-user me-2" />
                      Discharge (Office Att.)
                    </div>
                  )}
                </div>
              )}
           </>
          )}

          {/* ======== Admission Rule Master ========= */}
          {(flag === 1 || flag === 3) && (
            <div onClick={() => handleNavigate('/Rule')}>
              <i className="fa-solid fa-comments me-2" /> Admission Rule Master
            </div>
          )}

          {/* ======== Highlight Master ========= */}
          {(flag === 1 || flag === 3) && (
            <div onClick={() => handleNavigate('/Highlight')}>
              <i className="fa-regular fa-snowflake me-2" /> Highlight Master
            </div>
          )}

          {/* ======== Fee Master ========= */}
          {(flag === 1 || flag === 3) && (
           <>
              <div
                onClick={() => setActiveKey(activeKey === '0' ? null : '0')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '10px 15px',
                  cursor: 'pointer',
                  // borderBottom: '1px solid #ddd',
                  background: '#a2d6f8',
                }}
              >
                <span>
                  <i className="fa-solid fa-sack-dollar me-2" />
                  Fee Master
                </span>
                <span>{activeKey === '0' ? '▲' : '▼'}</span>
              </div>

              {activeKey === '0' && (
                <div style={{ paddingLeft: '30px', background: '#fff' }}>
                  <div
                    onClick={() => handleNavigate('/FeeType')}
                    style={{ padding: '8px 0', cursor: 'pointer' }}
                  >
                    <i className="fa-solid fa-indian-rupee-sign me-2" />
                    Fee Type Master
                  </div>
                  <div
                    onClick={() => handleNavigate('/FeeMaster1')}
                    style={{ padding: '8px 0', cursor: 'pointer' }}
                  >
                    <i className="fa-solid fa-rupee-sign me-2" />
                    Fees Amount Entry
                  </div>
                </div>
              )}
           </>
          )}

          {/* ======== Room Master ========= */}
          {(flag === 1 || flag === 3) && (
            <>            
                <div
                  onClick={() => setActiveKey(activeKey === '2' ? null : '2')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px 15px',
                    cursor: 'pointer',
                    // borderBottom: '1px solid #ddd',
                    background: '#a2d6f8',
                  }}
                >
                  <span>
                    <i className="fa-solid fa-house-medical me-2" />
                    Room Master
                  </span>
                  <span>{activeKey === '2' ? '▲' : '▼'}</span>
                </div>

                {activeKey === '2' && (
                  <div style={{ paddingLeft: '30px', background: '#fff' }}>
                    <div onClick={() => handleNavigate('/Block')} style={{ padding: '8px 0' }}>
                     <i className="fa-solid fa-building"></i> Block
                    </div>
                    <div onClick={() => handleNavigate('/room')} style={{ padding: '8px 0' }}>
                     <i className="fa-solid fa-house-user"></i> Room
                    </div>
                    <div onClick={() => handleNavigate('/Bed')} style={{ padding: '8px 0' }}>
                      <i className="fa-solid fa-bed"></i> Bed
                    </div>
                  </div>
                )}
              </>
          )}

          {/* ======== Gallery Master (for flag 1 and 3) ========= */}
          {(flag === 1 || flag === 3) && (
            <>         
                <div
                  onClick={() => setActiveKey(activeKey === '4' ? null : '4')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px 15px',
                    cursor: 'pointer',
                    // borderBottom: '1px solid #ddd',
                    background: '#a2d6f8',
                  }}
                >
                  <span>
                    <i className="fa-solid fa-image me-2" />
                    Gallery Master
                  </span>
                  <span>{activeKey === '4' ? '▲' : '▼'}</span>
                </div>

                {activeKey === '4' && (
                  <div style={{ paddingLeft: '30px', background: '#fff' }}>
                    <div
                      onClick={() => handleNavigate('/WebsiteDashboardImgMaster')}
                      style={{ padding: '8px 0', cursor: 'pointer' }}
                    >
                      <i className="fa-solid fa-layer-group me-2" />
                      Website Dashboard
                    </div>
                    <div
                      onClick={() => handleNavigate('/BoardingDirectorsImgMaster')}
                      style={{ padding: '8px 0', cursor: 'pointer' }}
                    >
                      <i className="fa-solid fa-user me-2" />
                      Boarding Director
                    </div>
                    <div
                      onClick={() => handleNavigate('/GalleryMaster')}
                      style={{ padding: '8px 0', cursor: 'pointer' }}
                    >
                      <i className="fa-solid fa-image me-2" />
                      Gallery Master
                    </div>
                  </div>
                )}
            </>
          )}

          {/* ======== Gallery Master (flag === 2 only) ========= */}
          {flag === 2 && (
            <div onClick={() => handleNavigate('/GalleryMaster')}>
              <i className="fa-solid fa-image me-2" /> Gallery Master
            </div>
          )}

     

        </div>
      )}
    </div>
  )
}

export default MobileNavbarAdmin
